import '../css/Dashboardpage.css';
import DocumentRequest from '../model/request/Documentrequest';
import DocumentstatusResponse from '../model/response/DocumentstatusResponse';
// import Documentpath from '../model/response/Documentpath';
import UpdateDetailsResponse from "../model/response/UpdateDetailsResponse";
import { Oval } from "react-loader-spinner";
import Popup from './Popup';
import { useEffect, useState } from 'react';
import { useLocation } from "react-router-dom";
import { useNavigate } from 'react-router-dom';
import ContactRequest from '../model/request/ContactRequest';
import ContactResponse from '../model/response/ContactResponse';



import { toast, ToastContainer } from 'react-toastify';
import ApiConfig from '../utils/ApiConfig';
import axios from 'axios';
import ApiResponse from '../model/response/ApiResponse';




function EmailEditpopup() {
    const rawVal = localStorage.getItem('loginVal');
    let loginVal = rawVal ? JSON.parse(rawVal) : null;
    let token = loginVal ? loginVal.token : null;

    var location = useLocation();
    var { profile } = location.state || {};

    const [activeuser, setActiveUser] = useState([]);

    const [email, setEmail] = useState();
    const [errors, setErrors] = useState({});
    // const [activeUser, setActiveUser] = useState([]);

    const [isLoading, setIsLoading] = useState(false);


    const navigation = useNavigate()

    function validate() {
        const newErrors = {};

        if (!email.trim()) {
            newErrors.email = 'Please enter your email';
        } else if (!/\S+@\S+\.\S+/.test(email)) {
            newErrors.email = 'Enter a valid email address';
        }
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    }

    async function handleSubmit() {
        if (validate()) {
            email = await ApiConfig.decrypt(email);

        }
    }


    function showToast(message) {
        toast.success(message, {
            position: "top-right",
            autoClose: 2000
        });
    }
    function showToastFailed(message) {
        toast.error(message, {
            position: "top-right",
            autoClose: 2000
        });
    }

    useEffect(() => {
        setIsLoading(true);


    }, []);




    async function EmailNewUpdate() {

        if (!validate()) return;

        setIsLoading(true);

        var request = new DocumentRequest();

        request.userId = loginVal.user_Id;
        request.contact = await ApiConfig.encrypt(email);
        request.isEmail = true;
        request.isPhone = false;



        console.log("Request:", JSON.stringify(request));

        axios.put(
            ApiConfig.getUrl("User/updateContact"),
            JSON.stringify(request),
            {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
            }
        )
             .then(response => {

                const api = ApiResponse.fromJson(response.data);

                if (api.statusCode == 200 && api.status == true) {
                    //    navigation('/Viewpage', { state: { userId: userId } });

                    showToast(api.response.message);
                     navigation('/ContactOtpscreen', { state: { userId: loginVal.user_Id, contact:email,isPhone:false,isEmail:true} });
                  
                    setIsLoading(false);

                } else {

                    showToastFailed(api.message);
                }
            })
            .catch(error => {

                console.error(error);

                setIsLoading(false);

                showToastFailed("Update failed");
            });
    }

    function clicktoEditprofile() {
        navigation('/Editprofile')

        setIsLoading(true);

    }
     const disableRightClick = (e) => {
    e.preventDefault();
  };





    return (
        <div className='text-center' onContextMenu={disableRightClick}>


            <h2>Email Update</h2>


                <input
                    type="text"
                    placeholder="Enter your Email.."
                    className="w-75 mt-3 p-2"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                />
                <span className="text-danger text-decoration-none">{errors.email}</span><br />




                <div className="btn-group mt-3">
                    <button style={{ backgroundColor: "var(--primary-color)" }} onClick={EmailNewUpdate} className="btn">Save</button>
                    <button style={{ backgroundColor: "lightgrey" }} className="btn" onClick={clicktoEditprofile}> Cancel</button>
                </div>
            
        </div>

    );
}

export default EmailEditpopup;

//

// 